import {useContext} from 'react';

// `import type` et non un import de valeur : sinon ce fichier retirerait au
// chargement différé de `MixpanelProvider` tout son intérêt, en réintroduisant
// une arête statique vers `mixpanel-browser`.
import type {MixPanelService} from './mixpanel.service';
import {MixpanelCtx} from './MixpanelCtx';

export function useMixpanelInstance(): MixPanelService {
  const ctx = useContext(MixpanelCtx);
  if (ctx === undefined) throw new Error('useMixpanelInstance must be used within <MixpanelProvider>');
  return ctx;
}
